module.exports = __webpack_public_path__ + "static/media/mobile.2761ed46.png";